import { createAsyncThunk } from "@reduxjs/toolkit";

import BaseAPI from "./BaseAPI";

export const fetchUserPermissions = createAsyncThunk(
    "access/fetchUserPermissions",
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.getWithAuth("/access", null, token);
            return data;
        } catch (err) {
            console.error('get access permission error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

export const getPrivacyPolicy = createAsyncThunk(
    "access/getPrivacyPolicy",
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.getWithAuth("/privacyPolicy", null, token);
            return data;
        } catch (err) {
            console.error('get privacy policy error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

export const getCopyRight = createAsyncThunk(
    "access/getCopyRight",
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.getWithAuth("/copyright", null, token);
            return data;
        } catch (err) {
            console.error('get copyright error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);